export default __webpack_public_path__ + "static/media/plain-sticker-P.6a930571.png";